import { Controller } from "stimulus"

export default class extends Controller {
  top(event) {
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: this.scrollBehavior })
  }

  bottom(event) {
    event.preventDefault()
    const top = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    )

    window.scrollTo({ top, behavior: this.scrollBehavior })
  }

  get scrollBehavior() {
    const reducedMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches

    return reducedMotion ? "auto" : "smooth"
  }

  toTarget(event) {
    const target = document.querySelector(event.currentTarget.dataset.scrollSelector)

    if (!target) {
      return
    }

    const offset = Number(event.currentTarget.dataset.scrollOffset || 0)
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset

    window.scrollTo({ top, behavior: "smooth" })
  }
}
